export function getWeather (state){
    return state.weather
  }